import {BronzeTabName} from '@src/dtos/analytics.dto';
import {DateFilterOptionNew, ReportName} from '@src/utils/enums';
import React, {useEffect, useMemo, useState} from 'react';
import {DateRangeObject} from '@src/utils/datesUtils';
import {useStores} from '@src/components/store';
import DateRangePicker from '@src/components/shared/date-range-picker/date-range-picker';
import Loader from '@src/components/shared/loader/loader';
import {observer} from 'mobx-react-lite';
import './reports.scss';
import {Dropdown} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import {ExportReport} from '@src/components/features/reports-and-logs/new-reports/export-report';
import {ReportContent} from '@src/components/features/reports-and-logs/new-reports/report-content';
import {removeSpacesAndStartWithLowerCase} from '@src/utils/string-normalization';

export const Reports = observer(() => {

    const {userPreferencesStore, reportsStore, fwVersionBronzeStore} = useStores();
    const [reportType, setReportType] = useState<ReportName>('' as ReportName);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setReportType(userPreferencesStore.reportsPreferences[0].reportName);
    }, []);

    const changeDateFilter = (selectedOption: string, range?: DateRangeObject) => {
        userPreferencesStore.updateAllReportsDate(selectedOption as DateFilterOptionNew, range);
        reportsStore.setDateRange(range ?? selectedOption);
        fwVersionBronzeStore.sendBronzeUpdateEvent(BronzeTabName.REPORTS);
    };

    const menuConfig = useMemo(() => {
        return {
            items: userPreferencesStore.reportsPreferences.map(item => ({key: item.reportName, label: item.reportName})),
            selectable: true,
            selectedKeys: [reportType],
            onSelect: ({ key }: any) => setReportType(key)
        };
    }, [reportType]);

    return (
        userPreferencesStore.isLoading ? <Loader type="full-screen"/> :
        <div className="bronze-reports">
            <div className="header-page">
                <div className="dropdown-menu-wrapper">
                    <Dropdown overlayClassName={'dropdown-overlay-menu bronze-reports-dropdown'} menu={menuConfig} trigger={['click']}>
                        <span>
                            {reportType}
                            <DownOutlined />
                        </span>
                    </Dropdown>
                </div>
                <div className="filter-and-export">
                    <DateRangePicker defaultValue={reportsStore.dateRange} onDateRangeChange={changeDateFilter}/>
                    <ExportReport reportName={removeSpacesAndStartWithLowerCase(reportType)}
                                                             isLoading={isLoading} contentClass={'bronze-reports'} />
                </div>
            </div>
            <ReportContent reportName={reportType} isLoading={isLoading} setIsLoading={setIsLoading} />
        </div>
    );
});